/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSupportBlockFragment} from '@amblique/contentful/app/contentful/fragments/support-block/base-support-block.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';

export const FullSupportBlockFragment = gql`
  ${BaseSupportBlockFragment}
  ${ImageFragment}
  ${LinkFragment}

  fragment FullSupportBlockFragment on SupportBlock {
    ...BaseSupportBlockFragment

    actionsCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    actionsCursorCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    image {
      ...ImageFragment
    }
  }
`;
